import { createContext, useCallback, useContext, useMemo, useState, ReactNode } from 'react';

interface SearchContextType {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  placeholder: string;
  setPlaceholder: (placeholder: string) => void;
  clearSearch: () => void;
}

const SearchContext = createContext<SearchContextType | undefined>(undefined);

export function SearchProvider({ children }: { children: ReactNode }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [placeholder, setPlaceholder] = useState('Search...');

  const clearSearch = useCallback(() => {
    setSearchQuery('');
  }, []);

  const value = useMemo(() => ({
    searchQuery,
    setSearchQuery,
    placeholder,
    setPlaceholder,
    clearSearch,
  }), [searchQuery, placeholder, clearSearch]);

  return (
    <SearchContext.Provider value={value}>
      {children}
    </SearchContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useSearch() {
  const context = useContext(SearchContext);
  if (context === undefined) {
    throw new Error('useSearch must be used within a SearchProvider');
  }
  return context;
}
